import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useModuleSettings } from '../../../components/moduleSettingsContext/ModuleSettingsContext';
import { users } from '../../../slices/userSlice';
import { encrypt } from '../../../common/enc_dec';
import userIcon from "../../../assets/avatar.png";
import moment from 'moment';
import Loader from '../../../components/loader';
import { Helmet } from 'react-helmet';
import DataTable from 'react-data-table-component';

const UserActivityReport = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userList } = useSelector((state) => state.users);
    const { search, setSearch, page, setPage, limit, setLimit, resetSettings } = useModuleSettings();

    useEffect(() => {
        dispatch(users({ payload: { search, page, limit } }));
    }, [dispatch, search, page, limit]);

    const handleView = (row) => {
        resetSettings();
        navigate(`/user-report/view?id=${encrypt(`${row.id}`)}`, { state: { id: row.id } });
    };

    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    const columns = [
        {
            name: "Sr No",
            selector: (row, index) => (page - 1) * limit + index + 1,
            sortable: false,
            width: "80px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "User Id",
            selector: (row, index) => row.id,
            sortable: true,
            minWidth: "100px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Profile Image",
            selector: (row) =>
                row.image ? (
                    <img src={row.image} alt="user image" style={{ width: "60px", height: "60px", padding: "5px" }} />
                ) : (
                    <img src={userIcon} alt="user image" style={{ width: "60px", height: "60px", padding: "5px" }} />
                ),
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Full Name",
            selector: (row) => <span className="text-capitalize">{row.full_name || "NA"}</span>,
            minWidth: "200px",
            maxWidth: "400px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Email",
            selector: (row) => row.email || "NA",
            minWidth: "300px",
            maxWidth: "400px",
            grow: 2,
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Phone Number",
            selector: (row) => (
                <>
                    {row.country_code && row.phone_number ? "+" + row.country_code + row.phone_number : "NA"}
                </>
            ),
            minWidth: "200px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Language",
            selector: (row, index) => row?.user_language?.name || "NA",
            sortable: true,
            minWidth: "200px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Joining Date",
            selector: (row) => moment(row.createdAt).format("DD-MMM-YYYY"),
            sortable: true,
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Action",
            selector: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button className="btn" onClick={() => handleView(row)}>
                        <i
                            className="fe-eye font-22 avatar-title text-primary"
                            style={{ color: "blue" }}
                        />
                    </button>
                </div>
            ),
            minWidth: "250px",
            style: {
                fontSize: "14px",
                display: "flex",
                justifyContent: "center",
            },
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center", // center the header cell
            },
        },
        cells: {
            style: {
                justifyContent: "center", // center the cell content
            },
        },
    };

    if (!userList?.data) {
        return (
            <Loader />
        );
    }

    return (
        <>
            <Helmet>
                <title>GUARDING.TECH | User</title>
            </Helmet>

            <div className="content-page">
                {/* <div>User</div> */}
                <div className="col-md-12 col-xl-12 mt-1">
                    <div className={`widget-rounded-circle card`}>
                        <div className="card-body">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <div>
                                    <h3 className="text-info">Users</h3>
                                </div>

                            </div>
                            <div className="row">
                                <DataTable
                                    title={null}
                                    columns={columns}
                                    data={userList?.data}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={userList?.paging?.total}
                                    paginationDefaultPage={page}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                                    onChangeRowsPerPage={(newrow) => setLimit(newrow)}
                                    onChangePage={(newPage) => setPage(newPage)}
                                    responsive
                                    selectableRowsHighlight
                                    highlightOnHover
                                    striped
                                    subHeader
                                    fixedHeader
                                    fixedFooter
                                    persistTableHead
                                    subHeaderWrap
                                    subHeaderAlign="left"
                                    noDataComponent={<h5 className="p-3">No Data Found</h5>}
                                    subHeaderComponent={
                                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", padding: "10px 0" }}>

                                            <div>
                                                <input
                                                    type="text"
                                                    value={search}
                                                    onChange={handleSearchChange}
                                                    placeholder="Search"
                                                    style={{ padding: "4px", borderRadius: "5px", border: "1px solid #ccc" }}
                                                />
                                            </div>
                                        </div>

                                    }
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserActivityReport;